var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNext(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 22,
    viewBox: "0 0 31 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.10192 0.421628C1.37427 -0.559993 0 0.225304 0 2.22781V7.41077C0 9.37401 0 12.633 0 14.5962V19.7792C0 21.7424 1.41353 22.567 3.10192 21.5854L7.57811 18.9939C9.30576 18.0123 12.0936 16.4024 13.8212 15.3815L18.2974 12.79C20.0251 11.8084 20.0251 10.1986 18.2974 9.17768L13.8212 6.5862C12.0936 5.60458 9.30576 3.99473 7.57811 2.97384L3.10192 0.421628Z",
    fill: "#603004"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1158 0.61792H25.3648C24.8936 0.61792 24.501 1.01057 24.501 1.48175V20.5644C24.501 21.0356 24.8936 21.4283 25.3648 21.4283H30.1158C30.587 21.4283 30.9797 21.0356 30.9797 20.5644V1.48175C30.9797 1.01057 30.587 0.61792 30.1158 0.61792Z",
    fill: "#603004"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.0cac9276124c247c41cfa3983775a1ae.svg";
export { ForwardRef as ReactComponent };